import { render, staticRenderFns } from "./AddNormal.vue?vue&type=template&id=65495947&scoped=true&"
import script from "./AddNormal.vue?vue&type=script&lang=js&"
export * from "./AddNormal.vue?vue&type=script&lang=js&"
import style0 from "./AddNormal.vue?vue&type=style&index=0&id=65495947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65495947",
  null
  
)

export default component.exports